import { css } from '@/styled-system/css';

export const headerRight = css({
  display: 'flex',
  alignItems: 'center',
  gap: '1x',
});

export const sectionHeading = css({
  fontSize: 'lg',
  fontWeight: '700',
  color: 'hpxBlue600',
  marginBottom: '2x',
});

export const layoutMediaContainer = css({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  aspectRatio: '4 / 3',
  borderRadius: '8px',
  overflow: 'hidden',
  md: {
    width: '50%',
    marginX: 'auto',
  },
});

export const floorPlanImage = css({
  width: '100%',
  height: '100%',
  display: 'block',
  objectFit: 'contain',
});

export const photoCarousel = css({
  position: 'relative',
  width: '100%',
  height: '100%',
  backgroundColor: 'hpxGrey100',
  userSelect: 'none',
});

export const photoCarouselTrack = css({
  display: 'flex',
  height: '100%',
  overflowX: 'auto',
  listStyle: 'none',
  padding: 0,
  margin: 0,
  scrollSnapType: 'x mandatory',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '-2px',
  },
});

export const photoCarouselSlide = css({
  flexShrink: 0,
  width: '100%',
  height: '100%',
  scrollSnapAlign: 'start',
});

export const photoCarouselSlideButton = css({
  display: 'block',
  width: '100%',
  height: '100%',
  padding: 0,
  border: 'none',
  backgroundColor: 'transparent',
  cursor: 'zoom-in',
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '-2px',
  },
});

export const photoCarouselImage = css({
  width: '100%',
  height: '100%',
  objectFit: 'contain',
  pointerEvents: 'none',
  userSelect: 'none',
});

export const photoCarouselArrowButton = css({
  display: 'none',
  md: {
    display: 'flex',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '36px',
    height: '36px',
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    border: 'none',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: 'hpxBlue600',
    zIndex: 'zIndexStep',
    transitionProperty: 'background-color, transform',
    transitionDuration: '0.2s',
    _hover: {
      backgroundColor: 'rgba(255, 255, 255, 1)',
      transform: 'translateY(-50%) scale(1.05)',
    },
    _disabled: {
      opacity: 0.4,
      cursor: 'default',
      _hover: {
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        transform: 'translateY(-50%)',
      },
    },
    _focusVisible: {
      outlineWidth: '2px',
      outlineStyle: 'solid',
      outlineColor: 'hpxTeal500',
      outlineOffset: '2px',
    },
  },
});

export const photoCarouselArrowButtonPrev = css({
  md: { left: '1x' },
});

export const photoCarouselArrowButtonNext = css({
  md: { right: '1x' },
});

export const photoCarouselCounter = css({
  position: 'absolute',
  bottom: '2x',
  left: '2x',
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  backgroundColor: 'rgba(0, 0, 0, 0.60)',
  color: 'hpxWhite',
  borderRadius: '4px',
  paddingX: '4px',
  paddingY: '6px',
  fontSize: 'sm',
  lineHeight: '1',
  whiteSpace: 'nowrap',
  fontWeight: '500',
  zIndex: 'zIndexStep',
  pointerEvents: 'none',
});

export const unitSpecs = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  listStyle: 'none',
  padding: 0,
  margin: 0,
  gap: '2x',
  paddingY: '2x',
  fontSize: 'sm',
  color: 'hpxGrey600',
});

export const specItem = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'xs',
});

export const specValue = css({
  fontWeight: '700',
  color: 'hpxBlue600',
});

export const sectionDivider = css({
  borderTopWidth: '1px',
  borderTopStyle: 'solid',
  borderTopColor: 'hpxGrey400',
  marginY: '3x',
});

export const buildingName = css({
  fontWeight: '700',
  fontSize: 'sm',
  color: 'hpxBlue600',
});

export const buildingAddress = css({
  fontSize: 'sm',
  color: 'hpxGrey600',
  marginTop: 'xs',
});

export const propertyLink = css({
  fontSize: 'sm',
  color: 'hpxTeal500',
  fontWeight: '600',
  textDecoration: 'none',
  marginTop: '1x',
  display: 'inline-block',
  _hover: {
    textDecoration: 'underline',
  },
});

export const managerName = css({
  fontSize: 'sm',
  fontWeight: '700',
  color: 'hpxBlue600',
  marginBottom: 'xs',
});

export const managerIcon = css({
  width: '16px',
  height: '16px',
});

export const verifiedBadge = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'xs',
  fontSize: 'sm',
  color: 'hpxTeal500',
  marginBottom: '2x',
});

export const verifiedIcon = css({
  width: '16px',
  height: '16px',
});

export const officeHours = css({
  fontSize: 'sm',
  color: 'hpxGrey600',
});

export const officeHoursLabel = css({
  display: 'flex',
  alignItems: 'center',
  gap: '1x',
  fontWeight: '700',
  color: 'hpxBlue600',
  marginBottom: 'xs',
});

export const officeHoursLine = css({
  lineHeight: '1.6',
  color: 'hpxBlue500',
});

export const footerActions = css({
  display: 'flex',
  gap: '1x',
  width: '100%',
});

export const unitSummary = css({});

export const unitSummaryTitle = css({
  fontSize: 'xl',
  fontWeight: '700',
  color: 'hpxBlue600',
});

export const unitSummarySpecs = css({
  fontSize: 'sm',
  color: 'hpxGrey600',
  marginTop: 'xs',
});

export const sectionsContainer = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '2x',
});
